// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","wrapper":"FRcC5VYkhgODEmiZQF5Qm","vertical":"yvObLUFNo2ANweHqVrGYb","radioWrapper":"_2Rx4x6Hb2CFCmYqXpWqkXY","label":"_3N6zS2rfuDqAkhT2AFM00m","input":"_2GxQtOxQBMUZV-o6H36TEd","textLabel":"gbI60bSgqVbEtdIKzTLEa","circle":"_1tgGgRDCSpIAm0bHl3SsAt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RadioGroup/RadioGroup.mod.css
// module id = 1121
// module chunks = 0